import { useMutation, useQuery, useQueryClient } from 'react-query';
import { tutorialAPI } from '@shared/apiClient';

const PROGRESS_QUERY_KEY = ['tutorialProgress'];

export const useTutorialProgress = (options = {}) => {
  return useQuery(
    PROGRESS_QUERY_KEY,
    async () => {
      const { data } = await tutorialAPI.getProgress();
      return data.progress ?? [];
    },
    {
      staleTime: 30000,
      ...options,
    }
  );
};

export const useSetTutorialProgress = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ chapterId, ...payload }) => tutorialAPI.updateProgress(chapterId, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(PROGRESS_QUERY_KEY);
      },
    }
  );
};

export const useResetTutorialChapter = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (chapterId) => tutorialAPI.resetChapter(chapterId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(PROGRESS_QUERY_KEY);
      },
    }
  );
};

export const useResetAllTutorialProgress = () => {
  const queryClient = useQueryClient();

  return useMutation(
    () => tutorialAPI.resetAll(),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(PROGRESS_QUERY_KEY);
      },
    }
  );
};

export const buildProgressMap = (progressRows = []) => {
  const map = {};
  progressRows.forEach((row) => {
    map[row.chapterId] = row;
  });
  return map;
};

export const getChapterDisplayStatus = (chapter, progressRow) => {
  if (!progressRow) return 'not_started';
  if (progressRow.status === 'completed') {
    if (
      chapter.version > (progressRow.completedVersion ?? 0)
    ) {
      return 'updated';
    }
    return 'completed';
  }
  if (progressRow.status === 'in_progress') return 'in_progress';
  return 'not_started';
};
